var _defs, _circle, _g, _g2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamesImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 337.934,
    height: 222.181,
    viewBox: "0 0 337.934 222.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.129,
    x2: 0.5,
    y2: 0.706,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b38774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f6451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.302,
    y1: -0.322,
    x2: 0.161,
    y2: 0.87,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 0.548,
    x2: 0.5,
    y2: 1.854,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: -1.541,
    x2: 0.5,
    y2: 1.788,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d233b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -0.366,
    y1: 0.5,
    x2: 1.705,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -0.859,
    y1: 0.5,
    x2: 3.982,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -1.161,
    y1: 0.5,
    x2: 7.123,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -1.081,
    y1: 0.5,
    x2: 2.082,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -0.235,
    y1: 0.5,
    x2: 4.58,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -0.146,
    y1: 0.5,
    x2: 2.849,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -3.648,
    y1: 0.5,
    x2: 2.025,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -0.639,
    y1: 0.5,
    x2: 6.475,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -21.473,
    y1: 0.5,
    x2: 12.271,
    y2: 0.5,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.5,
    y1: -1.183,
    x2: 0.5,
    y2: 2.033,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#353f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#444f7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.5,
    y1: 0.625,
    x2: 0.5,
    y2: -1.67,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c98e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b86744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.5,
    y1: 0.866,
    x2: 0.5,
    y2: 0.062,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -54.24,
    y1: 0.5,
    x2: -53.24,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e4535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#572f24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -107.297,
    y1: 0.542,
    x2: -109.461,
    y2: 0.493,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0.5,
    y1: 1.538,
    x2: 0.5,
    y2: -1.586,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0.5,
    y1: 1.673,
    x2: 0.5,
    y2: -0.114,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0.776,
    y1: -0.677,
    x2: 0.465,
    y2: 0.616,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 1.424,
    y1: -1.502,
    x2: -0.07,
    y2: 1.748,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0.5,
    y1: 1.331,
    x2: 0.5,
    y2: -0.053,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 1.56,
    y1: -0.679,
    x2: -0.054,
    y2: 1.146,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 1.506,
    y1: 1.514,
    x2: -0.223,
    y2: 0.008,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 1.302,
    y1: -0.368,
    x2: -0.113,
    y2: 0.711,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0.5,
    y1: 1.263,
    x2: 0.5,
    y2: -0.662,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 1.385,
    y1: 1.506,
    x2: 0.291,
    y2: 0.284,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 0.5,
    y1: -3.95,
    x2: 0.5,
    y2: 5.077,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbe8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4845f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 0.5,
    y1: -2.559,
    x2: 0.5,
    y2: 2.325,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 0.534,
    y1: -6.339,
    x2: 0.477,
    y2: 4.239,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 0.448,
    y1: -0.506,
    x2: 0.496,
    y2: 0.608,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 0.5,
    y1: -0.814,
    x2: 0.5,
    y2: 28.444,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 0.5,
    y1: -1.083,
    x2: 0.5,
    y2: 37.846,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 0.5,
    y1: -0.064,
    x2: 0.5,
    y2: 1.409,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 0.5,
    y1: 0.104,
    x2: 0.5,
    y2: 1.206,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4845f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4845f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 0.524,
    y1: -0.037,
    x2: 0.45,
    y2: 1.417,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 0.521,
    y1: 0.018,
    x2: 0.447,
    y2: 1.472,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 0.5,
    y1: 0.932,
    x2: 0.5,
    y2: -0.247,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 0.5,
    y1: -0.383,
    x2: 0.5,
    y2: 1.032,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 0.5,
    y1: 0.889,
    x2: 0.5,
    y2: 0.424,
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 0.5,
    y1: -0.481,
    x2: 0.5,
    y2: 1.041,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 0.102,
    y1: -1.488,
    x2: 0.667,
    y2: 1.347,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 0.5,
    y1: 0.936,
    x2: 0.5,
    y2: -0.248,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: -60.873,
    y1: 0.5,
    x2: -59.873,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: -74.774,
    y1: 0.5,
    x2: -73.774,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 0.5,
    y1: 0.09,
    x2: 0.5,
    y2: 2.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303a61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 0.5,
    y1: 1.581,
    x2: 0.5,
    y2: -0.553,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 0.491,
    y1: 0.014,
    x2: 0.52,
    y2: 1.512,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 0.49,
    y1: 0.008,
    x2: 0.519,
    y2: 1.506,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 0.49,
    y1: 0.002,
    x2: 0.519,
    y2: 1.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 0.492,
    y1: 0.103,
    x2: 0.521,
    y2: 1.601,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 0.492,
    y1: 0.097,
    x2: 0.521,
    y2: 1.595,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 0.492,
    y1: 0.091,
    x2: 0.521,
    y2: 1.589,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 2.243,
    y1: 25.322,
    x2: 3.832,
    y2: 47.948,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 2.165,
    y1: 24.21,
    x2: 3.753,
    y2: 46.835,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 2.087,
    y1: 23.098,
    x2: 3.675,
    y2: 45.723,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 3.386,
    y1: 41.597,
    x2: 4.974,
    y2: 64.222,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 3.308,
    y1: 40.485,
    x2: 4.896,
    y2: 63.11,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 3.229,
    y1: 39.373,
    x2: 4.818,
    y2: 61.998,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 0.667,
    y1: -1.162,
    x2: 0.23,
    y2: 3.181,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 0.653,
    y1: -1.018,
    x2: 0.216,
    y2: 3.325,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 0.5,
    y1: -0.185,
    x2: 0.5,
    y2: 1.829,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 0.514,
    y1: -0.652,
    x2: 0.486,
    y2: 1.024,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 0.5,
    y1: 2.295,
    x2: 0.5,
    y2: 0.908,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbe8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b56845"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 0.5,
    y1: 0.984,
    x2: 0.5,
    y2: 0.224,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#ffd182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#fff48c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 0.692,
    y1: 1.413,
    x2: 0.347,
    y2: -0.107,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d69e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d69e36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: -0.031,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcec2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9b80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#ck"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4785f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad614d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 2.315,
    y1: 0.542,
    x2: 0.152,
    y2: 0.493,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 0.5,
    y1: 0.029,
    x2: 0.5,
    y2: 0.944,
    xlinkHref: "#ck"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 0.5,
    y1: 1.306,
    x2: 0.5,
    y2: 0.756,
    xlinkHref: "#ck"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: -0.128,
    y1: -0.259,
    x2: 1.01,
    y2: 1.11,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 0.5,
    y1: 1.423,
    x2: 0.5,
    y2: -0.975,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: -0.939,
    y1: 0.5,
    x2: 1.327,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 0.5,
    y1: 1.316,
    x2: 0.5,
    y2: -0.902,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: -0.974,
    y1: 0.5,
    x2: 1.546,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 0.5,
    y1: 0.979,
    x2: 0.5,
    y2: 0.291,
    xlinkHref: "#ck"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 0.184,
    y1: -0.213,
    x2: 0.727,
    y2: 1.066,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 0.944,
    y1: -0.782,
    x2: -0.28,
    y2: 3.62,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c2c2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: -1.462,
    y1: 0.35,
    x2: 0.085,
    y2: -1.996,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7a197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c77964"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: -6.1,
    y1: -1.43,
    x2: 0.942,
    y2: -6.656,
    xlinkHref: "#cy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: -0.053,
    y1: 0.641,
    x2: -1.316,
    y2: -1.211,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384061"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: -4.191,
    y1: -1.231,
    x2: 0.754,
    y2: -1.231,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 0.512,
    y1: -0.039,
    x2: 0.472,
    y2: 1.641,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 0.733,
    y1: 1.034,
    x2: 0.183,
    y2: -0.062,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: -1.146,
    y1: 0.5,
    x2: 0.988,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 0.329,
    y1: 0.223,
    x2: 0.924,
    y2: 0.796,
    xlinkHref: "#bk"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: -0.171,
    y1: 1.482,
    x2: 1.425,
    y2: -0.647,
    xlinkHref: "#ck"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: -0.256,
    y1: 1.134,
    x2: 6.686,
    y2: -3.867,
    xlinkHref: "#ck"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 1.619,
    y1: 1.942,
    x2: 0.328,
    y2: 0.208,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: -2.529,
    y1: 0.5,
    x2: 2.617,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: 1.477,
    y1: -0.141,
    x2: 1.535,
    y2: 1.161,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebe4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#e9e1db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653,
    stopColor: "#e5dad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#decec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#d8c3b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: 0.502,
    y1: 0.103,
    x2: 0.492,
    y2: 2.573,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#f6f2ef",
    stopOpacity: 0.792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#ebe1db",
    stopOpacity: 0.514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#e3d4cc",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#ddcbc0",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#d9c5b9",
    stopOpacity: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#d8c3b7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: 0.303,
    y1: -1.382,
    x2: 0.462,
    y2: 0.137,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#ccd0d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#c9cdd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#c2c6ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#b5babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#a4a8a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#9da29f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: -0.011,
    y1: -0.641,
    x2: 0.73,
    y2: 0.937,
    xlinkHref: "#dm"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    x1: 0.048,
    y1: -0.449,
    x2: 0.671,
    y2: 0.839,
    xlinkHref: "#dm"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: -0.218,
    y1: -0.791,
    x2: 0.691,
    y2: 0.774,
    xlinkHref: "#dm"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dq",
    x1: 0.153,
    y1: -1.303,
    x2: 0.589,
    y2: 0.987,
    xlinkHref: "#dm"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 0.284,
    y1: -3.485,
    x2: 0.448,
    y2: -0.634,
    xlinkHref: "#dm"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.265 -113.712)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.493 116.94)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.904,
    cy: 104.904,
    r: 104.904,
    transform: "translate(38.428)",
    fill: "#ff9696"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.283,464.19h0a3.9,3.9,0,0,0,3.9,3.9H369.319a3.9,3.9,0,0,0,3.9-3.9h0a3.9,3.9,0,0,0-3.9-3.9H72.182A3.9,3.9,0,0,0,68.283,464.19Z",
    transform: "translate(-68.283 -249.137)",
    fill: "#e5e5e5",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.265 113.712)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.957 66.633)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.849 33.493)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.814,291.849,370.5,322.986,386.55,356h3.491l-11.2-40.123-24.222-40.3Z",
    transform: "translate(-340.814 -275.581)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.706,318.2,394.257,356h2.961l-11.2-40.123-24.222-40.3-2.17,2.556Z",
    transform: "translate(-347.991 -275.581)",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.289,309.965l-20.666-34.384-13.808,16.268,27.17,28.5A75.777,75.777,0,0,1,375.289,309.965Z",
    transform: "translate(-340.814 -275.581)",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.86 79.115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.714,403.482l-.378,7.476,19.31.042-.859-2.7-7.809-1.637-6.774-3.18Z",
    transform: "translate(-413.336 -403.482)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.58,408.687l-.123-.387-7.809-1.637-6.775-3.181h-1.161v1.081a4.123,4.123,0,0,0,4.124,4.123Z",
    transform: "translate(-415.006 -403.482)",
    fill: "url(#e)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.251,351a35.409,35.409,0,1,0,35.409,35.409A35.409,35.409,0,0,0,297.251,351Zm0,67.148a31.739,31.739,0,1,1,31.739-31.739A31.739,31.739,0,0,1,297.251,418.147Z",
    transform: "translate(-261.842 -350.999)",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.117,355.89A32.384,32.384,0,1,0,331.5,388.274,32.384,32.384,0,0,0,299.117,355.89Zm0,62.578a30.195,30.195,0,1,1,30.195-30.195A30.195,30.195,0,0,1,299.117,418.468Z",
    transform: "translate(-263.708 -352.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.892,406.947a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,319.892,406.947Z",
    transform: "translate(-282.381 -371.538)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.159 32.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.506,351a35.409,35.409,0,1,0,35.409,35.409A35.409,35.409,0,0,0,491.506,351Zm0,66.915a31.505,31.505,0,1,1,31.505-31.505A31.506,31.506,0,0,1,491.506,417.914Z",
    transform: "translate(-456.097 -350.999)",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.372,355.89a32.384,32.384,0,1,0,32.384,32.384A32.384,32.384,0,0,0,493.372,355.89Zm0,62.578a30.195,30.195,0,1,1,30.195-30.195A30.194,30.194,0,0,1,493.372,418.468Z",
    transform: "translate(-457.963 -352.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.146,406.947a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,514.146,406.947Z",
    transform: "translate(-476.636 -371.538)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.414,298.565l-1.039,1.621a21.415,21.415,0,0,1-18.03,9.861H468.963a1.882,1.882,0,0,0-1.666,2.759l2.779,5.279",
    transform: "translate(-375.224 -298.565)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6.918
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.63,334.218l1.828-2.037h-76.19l1.062,2.037Z",
    transform: "translate(-331.05 -311.388)",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.3,332.318H351.4L376.079,380h7.909Z",
    transform: "translate(-331.099 -311.44)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.875,314.079,357,343.305h3.919l-15.129-29.226Z",
    transform: "translate(-327.468 -304.483)",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.3,380.391l43.43-47.455h6.46l-43.43,47.455Z",
    transform: "translate(-347.084 -311.675)",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.366,389.939l28.679-31.23H348.21l-27.593,30.047a.874.874,0,0,0,.644,1.466h1.462A.875.875,0,0,0,323.366,389.939Z",
    transform: "translate(-319.27 -321.506)",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.609,406.281H319.627a1.044,1.044,0,0,0-1.044,1.044h0a1.043,1.043,0,0,0,1.044,1.043h50.592a1.043,1.043,0,0,0,1.044-1.043h0a1.044,1.044,0,0,0-1.044-1.044h-1.609",
    transform: "translate(-318.583 -339.652)",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.621,330.607l25.168,47.613a2.23,2.23,0,0,0,1.972,1.188h0a2.231,2.231,0,0,0,1.972-3.273l-24.2-45.777Z",
    transform: "translate(-375.431 -310.692)",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.171,308.971h20.043a1.016,1.016,0,0,1,.322,1.979l-12.976,4.344a6.1,6.1,0,0,1-7.161-2.644l-1.19-1.982A1.12,1.12,0,0,1,330.171,308.971Z",
    transform: "translate(-322.575 -302.534)",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.512,
    height: 2.389,
    transform: "translate(91.652 18.449)",
    fill: "url(#p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.283 59.472)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 20.364,
    y2: 4.967,
    transform: "translate(21.419 9.14)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.03
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.379,
    y2: 0.084,
    transform: "translate(36.387 13.633)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.084,
    cy: 9.084,
    r: 9.084,
    transform: "translate(12.364)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.364,
    y1: 4.967,
    transform: "translate(1.142 4.125)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.03
  }), /*#__PURE__*/React.createElement("line", {
    x2: 7.159,
    y2: 1.79,
    transform: "translate(0 2.697)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.618 2.377)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.257)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.741,
    height: 8.796,
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.247,251.558v8.8h-6.321a4.574,4.574,0,0,1-4.557-4.177l-.4-4.619Z",
    transform: "translate(-440.506 -251.558)",
    fill: "#9c6751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.812,240h-8.087a14.645,14.645,0,0,1-.344-2.493c-.349-6.8,5.566-12.317,12.387-12.233a12.446,12.446,0,0,1,12.081,12.557v7a5.551,5.551,0,0,1-6.885,5.388l-5.263-1.3a5.175,5.175,0,0,1-3.889-5.013Z",
    transform: "translate(-443.366 -225.276)",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.768,225.277c-6.822-.084-12.737,5.434-12.387,12.233a14.645,14.645,0,0,0,.344,2.493h8.087v3.9a5.142,5.142,0,0,0,.168,1.238,6.847,6.847,0,0,0,4.141-2.544l2.462-3.192,9.215-2.6A12.411,12.411,0,0,0,455.768,225.277Z",
    transform: "translate(-443.366 -225.276)",
    fill: "#9c6751"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.768,225.277a12.241,12.241,0,0,1,11,7.454h-7.741a.286.286,0,0,0-.286.286h0a2.785,2.785,0,0,1-2.785,2.785h-.1a.287.287,0,0,0-.286.286v5.161a.286.286,0,0,1-.286.286H444.2a13.444,13.444,0,0,1-.817-4.026C443.031,230.712,448.947,225.194,455.768,225.277Z",
    transform: "translate(-443.366 -225.277)",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.49,225.323c.393-.033.791-.051,1.191-.046a12.168,12.168,0,0,1,10.487,6.426h-7.487a3.694,3.694,0,0,0-3.638-2.729q-.277,0-.553.025Z",
    transform: "translate(-450.279 -225.277)",
    fill: "url(#u)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.637,0h0A1.637,1.637,0,0,1,3.275,1.637V4.824A1.637,1.637,0,0,1,1.637,6.461h0A1.637,1.637,0,0,1,0,4.824V1.637A1.637,1.637,0,0,1,1.637,0Z",
    transform: "translate(10.344 18.276) rotate(180)",
    fill: "url(#v)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.016 12.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.009,257.518l-68.747,21.257s-7.846-24.629,25.79-34.783c14.727-4.446,24.662-2.767,31.232.674.39.2,2.493,2.209,2.493,2.209h3.948Z",
    transform: "translate(-339.467 -241.307)",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.207,247.584c14.727-4.446,24.662-2.767,31.233.674.39.2,2.493,2.209,2.493,2.209h3.576l-1.783-3.592h-3.948s-2.1-2-2.493-2.209c-6.57-3.441-16.505-5.12-31.232-.674-33.636,10.155-25.79,34.784-25.79,34.784l1.452-.449C341.093,270.91,343.018,255.188,368.207,247.584Z",
    transform: "translate(-339.467 -241.307)",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.685,259.7l-34.28,10.581-19.257-1.194.886,12.53,55.244-17.082A20.635,20.635,0,0,0,414.685,259.7Z",
    transform: "translate(-347.737 -248.322)",
    fill: "#303a61",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.141,251.813l5.564,6.577,25.546-9.557-5.212-6.841a64.78,64.78,0,0,0-10.246,2.261A49.037,49.037,0,0,0,357.141,251.813Z",
    transform: "translate(-346.209 -241.568)",
    fill: "url(#y)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M474.812,245.657V250.2a1.176,1.176,0,0,1-1.177,1.177h0a1.176,1.176,0,0,1-1.177-1.177v-2.532H459.487v-2.009Z",
    transform: "translate(-337.231 -230.674)",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.33,239.1l2.462-3.192,10.869-3.071h0A12.682,12.682,0,0,0,448.767,221.5c-7.448.732-16.5,2.477-22.294,6.551a2.136,2.136,0,0,0,.037,3.527l13.565,9.043A6.874,6.874,0,0,0,449.33,239.1Z",
    transform: "translate(-425.559 -221.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.257,224.7h0a33.611,33.611,0,0,0-10.8,4.6,2.133,2.133,0,0,0,.054,3.515l13.565,9.043a6.874,6.874,0,0,0,9.254-1.521l2.462-3.192,10.665-3.014H446.693A9.437,9.437,0,0,1,437.257,224.7Z",
    transform: "translate(-425.557 -222.68)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.261 4.879)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 1.719,
    y2: 1.715,
    fill: "none",
    stroke: "#303a61",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  }), /*#__PURE__*/React.createElement("line", {
    x2: 3.921,
    y2: 3.911,
    transform: "translate(3.512 3.503)",
    fill: "none",
    stroke: "#303a61",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.489 3.136)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 1.719,
    y2: 1.715,
    fill: "none",
    stroke: "#303a61",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  }), /*#__PURE__*/React.createElement("line", {
    x2: 3.921,
    y2: 3.911,
    transform: "translate(3.512 3.503)",
    fill: "none",
    stroke: "#303a61",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.817 1.703)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 2.183,
    y2: 1.903,
    fill: "none",
    stroke: "#303a61",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.405,
    y2: 4.313,
    transform: "translate(3.976 3.692)",
    fill: "none",
    stroke: "#303a61",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.306
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.663 18.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.335,262.324l16,23.949,27.932,3.75v-2.834l-24.2-8.13L429.825,265.2c-2-8.385-3.447-11.835-8.9-14.1a6.7,6.7,0,0,0-5.119.014h0a6.733,6.733,0,0,0-3.463,9.209Z",
    transform: "translate(-411.644 -250.6)",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.4,309.146l7.067-.982,5.8,4.156-6.494,4.589-6.374-4.93Z",
    transform: "translate(-439.776 -272.557)",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.015,257.09l9.388,26.152,26.726,6.877v-.971l-24.2-8.13-3.245-13.859c-1.133-4.762-2.454-8.539-4.433-11.422Z",
    transform: "translate(-417.507 -252.56)",
    fill: "url(#ac)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.849 31.049)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.086 69.518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.349,384.014l-2.381,7.1,21.642,6.107-.1-2.831-9.909-5.353-5.845-4.247Z",
    transform: "translate(-361.969 -384.014)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.03,396.143l-.044-1.28-9.909-5.353-5.845-4.247h0a5.586,5.586,0,0,0,3.577,6.582Z",
    transform: "translate(-365.442 -384.491)",
    fill: "url(#ae)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.919,285.034l23.942,21.882a4.651,4.651,0,0,1,.479,6.357l-26.526,32.811-3.409-.773,14.461-33.219L353.7,300.239a9.5,9.5,0,0,1-2.421-14.35h0A9.5,9.5,0,0,1,364.919,285.034Z",
    transform: "translate(-343.939 -275.793)",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491,306.919l-23.942-21.882a9.5,9.5,0,0,0-11.648-.9,9.461,9.461,0,0,1,7.19,2.448l23.942,21.882a4.651,4.651,0,0,1,.479,6.357l-22.283,31.218.215.049,26.526-32.811A4.651,4.651,0,0,0,391.491,306.919Z",
    transform: "translate(-346.569 -275.796)",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.67,298.122,352.5,271.629l-11.688,18.712,27.345,16.068C372.2,303.451,376.4,300.728,380.67,298.122Z",
    transform: "translate(-340.814 -271.629)",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.229,302.9q2.578-1.671,5.2-3.273l-25.01-23.523-1.038-.525-4.472,4.2Z",
    transform: "translate(-346.571 -273.136)",
    fill: "url(#ai)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.128,456.023h26.056c-2.2-1.8-4.806-3.431-6.932-5.169-1.118-.914-2.438-1.929-3.954-1.476-.775.231-2.747,1.8-1.965,2.853a48.29,48.29,0,0,0-10.158-10.121,9.635,9.635,0,0,0-2.832-1.584,3.746,3.746,0,0,0-3.139.32A3.864,3.864,0,0,0,265.938,445a31.588,31.588,0,0,0,1.632,4.4,4.331,4.331,0,0,0-1.59-1.262,1.484,1.484,0,0,0-1.807.519,1.992,1.992,0,0,0,.152,1.712C265.527,453.065,267.643,454.606,270.128,456.023Z",
    transform: "translate(-262.678 -304.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.7,454.757h26.056c-2.2-1.8-4.806-3.431-6.932-5.169-1.118-.915-2.437-1.929-3.954-1.477-.774.231-2.747,1.8-1.964,2.853a48.293,48.293,0,0,0-10.158-10.121,9.623,9.623,0,0,0-2.832-1.584,3.747,3.747,0,0,0-3.139.32,3.866,3.866,0,0,0-1.266,4.148,31.568,31.568,0,0,0,1.632,4.4,4.329,4.329,0,0,0-1.591-1.263,1.485,1.485,0,0,0-1.807.52,1.991,1.991,0,0,0,.152,1.711C451.1,451.8,453.22,453.339,455.7,454.757Z",
    transform: "translate(-333.463 -304.445)",
    fill: "#e5e5e5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.106)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.723 60.153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.443,220.176l5.495-4.6.493-4.612H294.3l.89,4.612,5.758,4.6Z",
    transform: "translate(-263.284 -210.958)",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.26,222.587H255.169a17.631,17.631,0,0,0,7.621,13.91l5.149,16.676-2.967,18.38h30.6l-2.917-18.38L297.8,236.5a17.631,17.631,0,0,0,7.621-13.91H281.26Z",
    transform: "translate(-255.169 -215.394)",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.26,222.587H255.169a17.519,17.519,0,0,0,1.434,6.37h23.036l.932-3.813.931,3.813h22.485a17.519,17.519,0,0,0,1.434-6.37H281.26Z",
    transform: "translate(-255.169 -215.394)",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.99,215.571l-.89-4.612H283.228l-.493,4.612-3.079,2.581h-1.123l3.85,3.222h13.5l4.144-3.222h-.809Z",
    transform: "translate(-264.081 -210.958)",
    fill: "url(#am)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.467 26.065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.717,158.693h5.153a2.843,2.843,0,0,0,2.843-2.844h-10.84A2.843,2.843,0,0,0,210.717,158.693Z",
    transform: "translate(-207.873 -155.849)",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.074,157.986h6.011a2.137,2.137,0,0,0,2.137-2.137h-8.147Z",
    transform: "translate(-212.145 -155.849)",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.526,198.141l-1.167-.871a38.821,38.821,0,0,0-18.563-7.426h0l-1.215-1.59c-3.663-4.793-1.945-3.485-7.11-6.6l-1.008-.607-8.635-23.1h-3.312l5.217,28.416,8.2,10.4,24.561,17.662Z",
    transform: "translate(-209.263 -156.647)",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.316,234.068l-22.534-8.638L256.99,237.8l5.08,16.453Z",
    transform: "translate(-220.044 -182.39)",
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.327,189.844h0l-1.215-1.59c-3.663-4.793-1.945-3.485-7.11-6.6l-1.008-.607-8.635-23.1h-.829l7.3,24.506,8.261,9.726L252.275,204.3h.634l1.148-6.158-1.167-.871A38.825,38.825,0,0,0,234.327,189.844Z",
    transform: "translate(-210.794 -156.647)",
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.481,158.693h-5.153a2.843,2.843,0,0,1-2.844-2.844h10.84A2.843,2.843,0,0,1,373.481,158.693Z",
    transform: "translate(-333.06 -155.849)",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.783,157.986h-6.01a2.137,2.137,0,0,1-2.137-2.137h8.147Z",
    transform: "translate(-330.448 -155.849)",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.066,198.141l1.167-.871a38.825,38.825,0,0,1,18.564-7.426h0l1.215-1.59c3.663-4.793,1.945-3.485,7.111-6.6l1.007-.607,8.635-23.1h3.311l-5.217,28.416-8.2,10.4L316.1,214.423Z",
    transform: "translate(-313.066 -156.647)",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.8,189.844h0l1.215-1.59c3.663-4.793,1.945-3.485,7.111-6.6l1.007-.607,8.635-23.1h.828l-7.3,24.506-8.26,9.726L314.849,204.3h-.634l-1.149-6.158,1.167-.871A38.825,38.825,0,0,1,332.8,189.844Z",
    transform: "translate(-313.066 -156.647)",
    fill: "url(#av)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.74,233.238l-.765,20.341,5.018-16.255a17.764,17.764,0,0,0,1.793-1.426l13.9-10,.845-1.146Z",
    transform: "translate(-314.176 -182.132)",
    fill: "url(#aq)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.432 116.312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.275,301.748l9.71,41.63,4.042,52.258h-3.9l-10.447-36.5-1.992-14.993-22.114-42.392Z",
    transform: "translate(-280.575 -301.748)",
    fill: "url(#ax)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.311,419.231l-4.042-52.258-.784-3.364h-7.218a8.861,8.861,0,0,0,3.3,5.364l.62.479,6.607,49.779Z",
    transform: "translate(-296.859 -325.344)",
    fill: "url(#ay)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.845,338.49l-8.57-36.743h-24.7l19.167,36.743Z",
    transform: "translate(-280.575 -301.748)",
    fill: "url(#az)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.565,337.289l-8.29-35.541h-24.7l17.165,35.541Z",
    transform: "translate(-280.575 -301.747)",
    fill: "url(#ba)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.357,301.747h-1.115l8.29,35.541h1.115Z",
    transform: "translate(-294.561 -301.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.934,329.607l4.991,13.9h7.606l-3.209-14.142Z",
    transform: "translate(-291.392 -312.283)",
    fill: "url(#bb)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.322 92.588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.185,457.4l-.124-5.038,4.023-.935,5.843,4.881.471.2a23.322,23.322,0,0,1,9.4,7.268h0a.07.07,0,0,1-.056.113h-8.794a9.361,9.361,0,0,1-7.561-3.842h0Z",
    transform: "translate(-336.061 -451.43)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.186,460.048a23.306,23.306,0,0,0-5.789-3.537l-.471-.2-5.843-4.881-4.023.935,8.808,7.683Z",
    transform: "translate(-336.061 -451.43)",
    fill: "url(#bd)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.726 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.774,301.748l-9.327,41.63-4.042,50.959,4.023.935,10.323-36.138,1.992-14.993,22.276-42.392Z",
    transform: "translate(-249.405 -301.748)",
    fill: "url(#be)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.269,418.2l6.747-49.1h0a4.1,4.1,0,0,0,4.294-3.158l.5-2.155h-7.634l-.731,3.259L249.4,418Z",
    transform: "translate(-249.405 -325.409)",
    fill: "url(#ay)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.879,338.49l19.308-36.743H265.942l-8.232,36.743Z",
    transform: "translate(-252.573 -301.748)",
    fill: "url(#az)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.4,337.289l17.4-35.541H265.558L256.7,337.289Z",
    transform: "translate(-256.703 -301.747)",
    fill: "url(#ba)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.55,301.747h2.192l-8.29,35.541H261.26Z",
    transform: "translate(-258.441 -301.747)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 92.588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.607,457.4l.124-5.038-4.023-.935-5.843,4.881-.471.2a23.316,23.316,0,0,0-9.4,7.268h0a.07.07,0,0,0,.056.113h8.794a9.36,9.36,0,0,0,7.561-3.842h0Z",
    transform: "translate(-223.982 -451.43)",
    fill: "url(#bi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.839,460.048a23.306,23.306,0,0,1,5.789-3.537l.471-.2,5.843-4.881,4.023.935-8.808,7.683Z",
    transform: "translate(-226.216 -451.43)",
    fill: "url(#bj)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.843,301.747H270.231l-1.276,5.121h33.082Z",
    transform: "translate(-241.136 -301.747)",
    fill: "url(#bk)"
  })), /*#__PURE__*/React.createElement("line", {
    x2: 153.738,
    transform: "translate(23.358 24.912)",
    fill: "none",
    stroke: "#303a61",
    strokeMiterlimit: 10,
    strokeWidth: 3.816
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 49.825,
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 49.825,
    transform: "translate(11.472)",
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 49.825,
    transform: "translate(22.945)",
    fill: "url(#bl)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 49.825,
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 49.825,
    transform: "translate(11.472)",
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 49.825,
    transform: "translate(22.945)",
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 19.143,
    fill: "url(#br)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 19.143,
    transform: "translate(11.472)",
    fill: "url(#bs)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 19.143,
    transform: "translate(22.945)",
    fill: "url(#bt)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 19.143,
    fill: "url(#bu)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 19.143,
    transform: "translate(11.472)",
    fill: "url(#bv)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 19.143,
    transform: "translate(22.945)",
    fill: "url(#bw)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 2.607,
    fill: "url(#bx)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 2.607,
    transform: "translate(11.472)",
    fill: "url(#by)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 2.607,
    transform: "translate(22.945)",
    fill: "url(#bz)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 2.607,
    fill: "url(#ca)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 2.607,
    transform: "translate(11.472)",
    fill: "url(#cb)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.074,
    height: 2.607,
    transform: "translate(22.945)",
    fill: "url(#cc)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.107 50.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.082,
    height: 6.421,
    rx: 1.541,
    fill: "url(#cd)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.082,
    height: 6.421,
    rx: 1.541,
    transform: "translate(19.178)",
    fill: "url(#ce)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.43 37.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.862,202.932H289.4a6.874,6.874,0,0,1-6.76-5.527l-1.892-10.9c-1.071-6.177,2.532-12.262,8.281-12.262h3.2c5.748,0,9.352,6.085,8.281,12.262l-1.892,10.9A6.874,6.874,0,0,1,291.862,202.932Z",
    transform: "translate(-280.562 -174.239)",
    fill: "url(#cf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.493,174.239h-1.519v28.693h1.148a6.874,6.874,0,0,0,6.76-5.527l1.892-10.9C307.845,180.324,304.241,174.239,298.493,174.239Z",
    transform: "translate(-286.822 -174.239)",
    fill: "url(#cg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.233,174.239h-3.2c-5.748,0-9.352,6.085-8.281,12.262l1.126,6.494h1.384l.073-11a2.4,2.4,0,0,1,2.169-2.638h10.258a2.4,2.4,0,0,1,2.169,2.638l.072,11h1.384l1.126-6.494C301.585,180.324,297.981,174.239,292.233,174.239Z",
    transform: "translate(-280.562 -174.239)",
    fill: "url(#ch)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.581 65.565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.661,241.034c-1-6.417-1.99-14.854-2.567-21.327l-2.467,1.675v10.746H275V221.42l-2.352-1.183c-.577,6.474-1.681,14.38-2.682,20.8l3.434,11.041-3.912,21.11H302.14l-3.912-21.11Z",
    transform: "translate(-269.489 -219.707)",
    fill: "url(#ci)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.228,263.736l3.433-11.041-6.215,6.366h-12.14l-8.265-8.782,6.457,10.977L292.6,272.363H278.528l-5.127-8.627-3.912,21.11H302.14Z",
    transform: "translate(-269.489 -231.368)",
    fill: "url(#cj)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 85.102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.826)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.593)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.408 16.257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.45,277.573v8.8h15.99l10.751-8.8Z",
    transform: "translate(-127.45 -277.573)",
    fill: "url(#ck)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,277.573v8.8h6.321a4.574,4.574,0,0,0,4.557-4.177l.4-4.619Z",
    transform: "translate(-127.45 -277.573)",
    fill: "#eb8f76"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.744,266.018h8.087a14.649,14.649,0,0,0,.343-2.492c.35-6.8-5.565-12.317-12.387-12.233a12.446,12.446,0,0,0-12.081,12.557v7a5.551,5.551,0,0,0,6.885,5.388l5.262-1.3a5.175,5.175,0,0,0,3.89-5.013Z",
    transform: "translate(-118.707 -251.292)",
    fill: "url(#cl)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.453,251.292a12.24,12.24,0,0,0-11,7.454h7.741a.287.287,0,0,1,.286.286h0a2.785,2.785,0,0,0,2.785,2.785h.1a.286.286,0,0,1,.286.286v5.161a.286.286,0,0,0,.286.286h11.085a13.406,13.406,0,0,0,.817-4.026C144.19,256.727,138.274,251.209,131.453,251.292Z",
    transform: "translate(-120.451 -251.292)",
    fill: "url(#cm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.961,251.339c-.393-.033-.791-.051-1.191-.046a12.171,12.171,0,0,0-10.488,6.426h7.487a3.7,3.7,0,0,1,3.639-2.729c.184,0,.369.009.553.025Z",
    transform: "translate(-120.768 -251.292)",
    fill: "url(#cn)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 3.275,
    height: 6.461,
    rx: 1.637,
    transform: "translate(14.138 11.815)",
    fill: "url(#co)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.054 50.587)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.585)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.481,364.918l28.648-15.565c-.643-1.147-1.286-2.295-1.94-3.437-1.6-2.8-3.23-5.576-4.926-8.318q-.387-.625-.764-1.255L159.57,359.7a3.725,3.725,0,0,0-1.4,3.979l11.917,44.137h4.341l-.241-29.662Z",
    transform: "translate(-158.043 -334.905)",
    fill: "url(#cp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.172,378.084l11.917,44.137h.859l-9.736-47.379-1.642-.737A3.725,3.725,0,0,0,158.172,378.084Z",
    transform: "translate(-158.043 -349.309)",
    fill: "url(#cq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.3,359.81l11.244,5,28.443-15.454c-.643-1.147-1.286-2.295-1.94-3.437-1.6-2.8-3.23-5.576-4.926-8.318q-.387-.625-.764-1.255L160.432,359.7C160.387,359.735,160.349,359.775,160.3,359.81Z",
    transform: "translate(-158.906 -334.905)",
    fill: "#d47157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.561,345.03c-1.6-2.8-3.23-5.576-4.926-8.318-.551-.89-1.089-1.785-1.6-2.693L159.019,357.7l17.322,4.937,22.55-15.25C198.448,346.6,198.01,345.812,197.561,345.03Z",
    transform: "translate(-158.416 -334.018)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 72.912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.193,451.891l3.04,7.777h-26.3l5.69-4.983h9.468l3.758-2.794Z",
    transform: "translate(-146.936 -451.891)",
    fill: "url(#cr)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.024,451.891h-1.533l-3.758,2.794h-9.468l-3.033,2.657h12.342a5.45,5.45,0,0,0,5.45-5.451Z",
    transform: "translate(-148.575 -451.891)",
    fill: "url(#cs)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.5,333.952v2.926a9.191,9.191,0,0,1-9.191,9.191H216.561a9.309,9.309,0,0,1-9.309-9.281h0Z",
    transform: "translate(-169.943 -333.408)",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.256)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.547 73.497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.645,451.891l4.111,8.41H206.435l4.635-5.273h3l4.542-3.137Z",
    transform: "translate(-206.435 -451.891)",
    fill: "url(#ct)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,451.891h-2.132l-4.543,3.137h-3l-2.034,2.314h8.948a2.762,2.762,0,0,0,2.762-2.763Z",
    transform: "translate(-208.039 -451.891)",
    fill: "url(#cu)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.821,334.631l-28.957,32.422a3.726,3.726,0,0,0-.21,4.707l25.989,34.9h5.031l-12.547-30.747-6.091-6.355,29.652-22.618a11.887,11.887,0,0,0,4.61-9.4v-4.233Z",
    transform: "translate(-182.917 -333.162)",
    fill: "url(#cv)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.162,334.631l-28.957,32.422a3.708,3.708,0,0,0-.393.542h15.137l27.081-20.656a11.887,11.887,0,0,0,4.61-9.4v-4.233Z",
    transform: "translate(-183.258 -333.162)",
    fill: "#eb8f76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.1,365.2l20.27-19.432a11.076,11.076,0,0,0,4.295-8.756v-3.943L212.521,334.4l-27.928,30.8Z",
    transform: "translate(-183.556 -333.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.551,427.8l-24.123-34.121,1.178-1.472v-3.47h-5.142a3.726,3.726,0,0,0,.192,4.164l25.989,34.9Z",
    transform: "translate(-182.917 -354.306)",
    fill: "url(#cw)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M236.638,333.073l-30.875.585-8.134,6.016,38.991-1.238a9.09,9.09,0,0,0,.205-1.893v-2.926l-.187.016Z",
    transform: "translate(-166.272 -333.073)",
    fill: "url(#cx)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.308 23.449)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.593,311.663l-15.968,11.08-19.6,11.57,2.291,2.143,21.816-9.1,18.167-8.465C116.042,316.505,113.761,314.135,111.593,311.663Z",
    transform: "translate(-69.143 -311.663)",
    fill: "url(#cy)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.782,348.28,65.1,352.636l-.206,6.772,9.284-2.08-.109-6.9Z",
    transform: "translate(-64.898 -325.63)",
    fill: "url(#cz)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.171,321.329l5.226-2.435c-2.259-2.39-4.54-4.76-6.708-7.231l-4.6,3.191Z",
    transform: "translate(-126.091 -311.663)",
    fill: "#b36d5a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.111,290.267c-3.456-3.543-13.682,2.874-13.682,2.874l-18.31,12.037,7.733,7.548L159.983,300.8C162.412,299.418,162.114,293.346,159.111,290.267Z",
    transform: "translate(-127.119 -289.2)",
    fill: "url(#da)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.649,298.558l8.549-5.845a14.433,14.433,0,0,1,5.995-2.352c-.028-.03-.053-.064-.082-.093-3.456-3.543-13.682,2.874-13.682,2.874l-18.31,12.037,3,2.93Z",
    transform: "translate(-127.119 -289.2)",
    fill: "url(#db)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.427 15.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.41,276.666h-8.042L140.12,288.022l8.123.811Z",
    transform: "translate(-136.709 -276.281)",
    fill: "url(#dc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6,291.983l15.661-12.609a14.466,14.466,0,0,1,7.762-3.134,51.905,51.905,0,0,1,33.886,9.018,56.385,56.385,0,0,1,19.615,23.782l1.257,2.823-36.346,3.389v-9.187Z",
    transform: "translate(-134.605 -276.044)",
    fill: "url(#dd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.359,289.379l8.067-6.495a14.473,14.473,0,0,1,7.762-3.133,51.905,51.905,0,0,1,33.886,9.018,55.133,55.133,0,0,1,14.844,15.1,55.667,55.667,0,0,0-17-18.613,51.905,51.905,0,0,0-33.886-9.018,14.466,14.466,0,0,0-7.762,3.134L134.6,291.983l4.46,1.5Z",
    transform: "translate(-134.605 -276.044)",
    fill: "url(#de)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.866,319.987l-3.6-15.358-45.11-12.648-7.553,6.081,41.835,14.083v9.187Z",
    transform: "translate(-134.605 -282.123)",
    fill: "url(#df)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.3,306.626,93.25,318.918,74.614,331.982l2.45,1.958L98.1,323.168l17.452-9.856C113.117,311.106,110.658,308.921,108.3,306.626Z",
    transform: "translate(-68.296 -306.626)",
    fill: "url(#dg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.718,347.618,64.4,352.482l.323,6.767,9.093-2.8-.647-6.875Z",
    transform: "translate(-64.4 -322.262)",
    fill: "url(#dh)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.637,316.148l5.021-2.836c-2.439-2.206-4.9-4.391-7.253-6.686l-4.335,3.539Z",
    transform: "translate(-122.07 -306.626)",
    fill: "#eb8f76"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.687,281.893c-3.722-3.263-13.416,3.933-13.416,3.933l-17.316,13.429,8.3,6.922,24.125-13.855C157.692,290.758,156.921,284.728,153.687,281.893Z",
    transform: "translate(-122.955 -281.044)",
    fill: "url(#di)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.915,291.286l8.067-6.495a14.428,14.428,0,0,1,5.793-2.811c-.03-.028-.058-.06-.088-.087-3.722-3.263-13.416,3.933-13.416,3.933l-17.316,13.429,3.221,2.687Z",
    transform: "translate(-122.955 -281.044)",
    fill: "url(#dj)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.451)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.297,
    cy: 14.297,
    r: 14.297,
    transform: "matrix(0.841, -0.541, 0.541, 0.841, 0, 15.466)",
    fill: "url(#dk)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.092,
    cy: 5.847,
    rx: 9.092,
    ry: 5.847,
    transform: "translate(10.748 6.002)",
    fill: "url(#dl)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.461 5.541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6,287.842q-.054-.322-.121-.64c-3.787,5.38-17.342,3.186-17.482,3.163l-.071-.012-.066.028a15.352,15.352,0,0,0-4.135,2.851,9.563,9.563,0,0,0-3.108,6.244q.225.263.462.517c.05-5.772,6.216-8.816,6.911-9.14C47.184,291.044,59.457,292.874,63.6,287.842Z",
    transform: "translate(-35.202 -275.981)",
    fill: "url(#dm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.091,285.475l.482-.02a18.52,18.52,0,0,0-3.238-10.405,11.778,11.778,0,0,0-1.713-1.881q-.205.146-.406.3C43.838,274.866,46.788,278.366,47.091,285.475Z",
    transform: "translate(-36.573 -270.628)",
    fill: "url(#dn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.873,269.128a34.253,34.253,0,0,1,5.9,15.014l.479-.061a34.785,34.785,0,0,0-5.839-15.021Q53.142,269.09,52.873,269.128Z",
    transform: "translate(-40.638 -269.061)",
    fill: "url(#do)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.883,271.539a26.073,26.073,0,0,1,3.885,12.41l.481-.035a27.154,27.154,0,0,0-3.5-11.884Q67.326,271.77,66.883,271.539Z",
    transform: "translate(-45.982 -270.006)",
    fill: "url(#dp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.065,279.666a17.315,17.315,0,0,0-4.821,2.573,14.286,14.286,0,0,0-4.147,4.8q-.012.556.019,1.1c2.479-5.915,9.013-7.994,9.09-8.017Z",
    transform: "translate(-33.094 -273.106)",
    fill: "url(#dq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.264,303.164a20.649,20.649,0,0,1-8.13-3.038l-.278.395a21.154,21.154,0,0,0,8.322,3.119,17.835,17.835,0,0,0,2.5.178c3.808,0,8.521-1.256,13.008-5.85q.139-.474.245-.962C59.463,301.928,54.2,304,48.264,303.164Z",
    transform: "translate(-35.673 -279.72)",
    fill: "url(#dr)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesImg);
export default __webpack_public_path__ + "static/media/games_img.0c2742e92c13d587c739320242d92815.svg";
export { ForwardRef as ReactComponent };